import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import Slider from "react-slick";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import toast from "react-hot-toast";
import {
  BASE_URL,
  deleteSliderImageApi,
  getSliderImagesApi,
  IMG_URL,
} from "../../helper/api_helper";

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      onClick={onClick}
      type="button"
      className={`${className} slick-next slick-arrow`}
    >
      <Icon icon="ic:outline-keyboard-arrow-right" className="menu-icon" />
    </button>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      onClick={onClick}
      type="button"
      className={`${className} slick-prev slick-arrow`}
    >
      <Icon icon="ic:outline-keyboard-arrow-left" className="menu-icon" />
    </button>
  );
}

const SliderManagement = () => {
  const [sliderImage, setSliderImage] = useState(null);
  const [isSliderAddOpen, setIsSliderAddOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [firstSlider, setFirstSlider] = useState([]);
  const [bannerTitle, setBannerTitle] = useState("");
  const [bannerDescription, setBannerDescription] = useState("");
  const [bannerLink, setBannerLink] = useState("");
  const [addButtonFields, setAddButtonFields] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const settings = {
    dots: false,
    arrows: true,
    infinite: firstSlider.length > 1,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  const firstSliderGet = async () => {
    try {
      let response = await getSliderImagesApi();
      setFirstSlider(response.data);
      console.log("First Slider Images", response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    firstSliderGet();
  }, []);

  const handleSliderDelete = async (sliderId) => {
    try {
      const response = await deleteSliderImageApi({ id: sliderId });
      toast.success(response?.message || "Image deleted successfully");
      firstSliderGet();
    } catch (error) {
      toast.error(error || "Something went wrong");
      console.log(error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const newImage = {
      src: URL.createObjectURL(file),
      file,
    };
    setSliderImage(newImage);
    e.target.value = "";
  };

  const removeImageChange = (src) => {
    URL.revokeObjectURL(src);
    setSliderImage(null);
  };

  const resetForm = () => {
    setSliderImage(null);
    setBannerTitle("");
    setBannerDescription("");
    setBannerLink("");
    setIsEditMode(false);
    setEditingId(null);
    setIsSliderAddOpen(false);
    setButtonText("")
    setAddButtonFields(false)
  };

  const handleEdit = (item) => {
    console.log("EDIT ITEMS ::",item);
    if(item?.buttonText){
      setAddButtonFields(true)
      setButtonText(item?.buttonText || "")
    }
    setIsEditMode(true);
    setEditingId(item.id);
    setBannerTitle(item.bannerTitle || "");
    setBannerDescription(item.bannerDescription || "");
    setBannerLink(item.bannerLink || "");
    setIsSliderAddOpen(true);
  };

  const handleSliderUpload = async () => {
    if (!isEditMode && !sliderImage) {
      toast.error("Please upload a slider image first.");
      return;
    }
    if (!bannerTitle) {
      toast.error("Please enter banner title");
      return;
    }
    if (!bannerDescription) {
      toast.error("Please enter banner description");
      return;
    }
    if (addButtonFields) {
      if (!buttonText) {
        toast.error("Please enter button text");
        return;
      }
      if (!bannerLink) {
        toast.error("Please enter banner link");
        return;
      }
    }

    const formData = new FormData();
    if (sliderImage) {
      formData.append("image", sliderImage.file);
    }
    formData.append("bannerTitle", bannerTitle);
    formData.append("bannerDescription", bannerDescription);
    formData.append("bannerLink", bannerLink);
    formData.append("buttonText",buttonText)
    if (isEditMode) {
      formData.append("id", editingId);
    }

    const toastId = toast.loading(
      isEditMode ? "Updating slider..." : "Uploading slider image..."
    );

    try {
      const url = isEditMode
        ? `${BASE_URL}/slider/update-image`
        : `${BASE_URL}/slider/upload-image`;

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(
        response.data.message ||
          (isEditMode
            ? "Slider updated successfully!"
            : "Slider image uploaded successfully!"),
        { id: toastId }
      );

      resetForm();
      firstSliderGet();
    } catch (error) {
      if (error?.code === "ERR_NETWORK") {
        toast.error("Image size is too large. Please upload a smaller file.", {
          id: toastId,
        });
      } else {
        toast.error(error?.response?.data?.message || "Something went wrong.", {
          id: toastId,
        });
      }
    }
  };
  const linkOptions = [
    { label: "Home", value: "https://www.sshealthconnect.com/" },
    { label: "About Us", value: "https://www.sshealthconnect.com/about" },
    { label: "Products", value: "https://www.sshealthconnect.com/products" },
    { label: "Contact", value: "https://www.sshealthconnect.com/contact" },
    { label: "Blog", value: "https://www.sshealthconnect.com/blog" },
  ];
  
  const isDisabled =
  (!isEditMode && !sliderImage) ||
  !bannerTitle ||
  !bannerDescription ||
  (addButtonFields && (!bannerLink || !buttonText));
  return (
    <MasterLayout>
      <Breadcrumb title="Slider Images Management" />
      <div className="row gy-4">
        <div
          className="card h-100 radius-12 overflow-hidden arrow-carousel"
          style={{ padding: "10px" }}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ padding: "10px 0px" }}
          >
            <h6 className="text-muted">Slider Images</h6>
            <button
              type="button"
              onClick={() => {
                resetForm();
                setIsSliderAddOpen(true);
              }}
              className="btn btn-primary-600 radius-8 px-20 py-11"
            >
              + Add Slider Image
            </button>
          </div>
          {firstSlider?.length === 0 ? (
            <div className="text-center p-4">No slider image found</div>
          ) : (
            <Slider {...settings}>
              {firstSlider?.map((item, index) => (
                <div
                  key={index}
                  className="position-relative slider-item-wrapper"
                >
                  {/* Background Image with Overlay */}
                  <div className="slider-background">
                    <img
                      src={`${IMG_URL}/${item?.image}`}
                      alt={`slider-${index}`}
                      className="slider-bg-image"
                    />
                    <div className="slider-overlay"></div>
                  </div>

                  {/* Content Overlay */}
                  <div className="slider-content">
                    <div className="slider-badge">
                      <Icon icon="mdi:heart-pulse" className="me-2" />
                      YOUR TRUSTED MEDICAL PARTNER
                    </div>

                    <h1 className="slider-title">
                      {item?.bannerTitle ||
                        "Need an Unapproved or Unavailable Medicine in India"}
                    </h1>

                    <p className="slider-description">
                      {item?.bannerDescription ||
                        "Providing comprehensive healthcare solutions across India with reliable service and expert guidance."}
                    </p>

                    {item?.bannerLink && (
                      <a
                        href={item?.bannerLink}
                        className="slider-cta-button"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item?.buttonText || "Get Started"}
                        <Icon icon="mdi:arrow-right" className="ms-2" />
                      </a>
                    )}
                  </div>

                  {/* Action Buttons */}
                  <div className="slider-actions">
                    <button
                      type="button"
                      className="action-btn edit-btn"
                      title="Edit"
                      onClick={() => handleEdit(item)}
                    >
                      <Icon icon="mdi:pencil-outline" className="icon" />
                    </button>
                    <button
                      type="button"
                      className="action-btn delete-btn"
                      title="Delete"
                      onClick={() => handleSliderDelete(item?.id)}
                    >
                      <Icon icon="mdi:trash-can-outline" className="icon" />
                    </button>
                  </div>
                </div>
              ))}
            </Slider>
          )}
        </div>
      </div>

      {/* Modal for Add/Edit */}
      {isSliderAddOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div
            className="modal-dialog modal-lg modal-dialog-centered"
            style={{ zIndex: 11122 }}
          >
            <div
              className="modal-content radius-16 bg-base"
              style={{ maxWidth: "125vh" }}
            >
              <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                <h1 className="modal-title fs-5">
                  {isEditMode ? "Edit Slider Image" : "Add Slider Image"}
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={resetForm}
                />
              </div>
              <div className="modal-body p-24">
                <form>
                  <div className="row">
                    <div className="card-body p-0">
                      <div
                        className="upload-image-wrapper d-flex flex-column gap-3 w-100"
                        style={{ justifyContent: "center" }}
                      >
                        <div
                          className="uploaded-imgs-container"
                          style={{ justifyContent: "center", display: "flex" }}
                        >
                          {sliderImage && (
                            <div
                              className="position-relative border input-form-light radius-12 overflow-hidden border-dashed bg-neutral-50"
                              style={{
                                width: "100%",
                                maxWidth: "600px",
                                height: "200px",
                              }}
                            >
                              <button
                                type="button"
                                className="uploaded-img__remove position-absolute top-0 end-0 z-1 text-2xxl line-height-1 m-8 d-flex"
                                onClick={() =>
                                  removeImageChange(sliderImage.src)
                                }
                              >
                                <Icon
                                  icon="radix-icons:cross-2"
                                  className="text-xl text-danger-600"
                                />
                              </button>
                              <img
                                className="w-100 h-100 object-fit-cover"
                                src={sliderImage.src}
                                alt="Slider Preview"
                              />
                            </div>
                          )}
                        </div>
                        {!sliderImage && (
                          <label
                            className="upload-file-single border input-form-light radius-12 overflow-hidden border-dashed bg-neutral-50 bg-hover-neutral-200 d-flex align-items-center justify-content-center flex-column gap-2"
                            htmlFor="upload-slider"
                            style={{
                              width: "100%",
                              maxWidth: "600px",
                              height: "200px",
                              margin: "auto",
                            }}
                          >
                            <Icon
                              icon="solar:camera-outline"
                              className="text-2xl text-secondary-light"
                            />
                            <span className="fw-semibold text-secondary-light">
                              {isEditMode
                                ? "Upload New Image (Optional)"
                                : "Upload Slider Image"}
                            </span>
                            <input
                              id="upload-slider"
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                          </label>
                        )}
                      </div>
                    </div>

                    {/* Banner Title Field */}
                    <div className="col-12 mt-24">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Banner Title <span className="text-danger-600">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control radius-8"
                        placeholder="Enter banner title"
                        value={bannerTitle}
                        onChange={(e) => setBannerTitle(e.target.value)}
                      />
                    </div>

                    {/* Banner Description Field */}
                    <div className="col-12 mt-16">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Banner Description{" "}
                        <span className="text-danger-600">*</span>
                      </label>
                      <textarea
                        className="form-control radius-8"
                        rows="3"
                        placeholder="Enter banner description"
                        value={bannerDescription}
                        onChange={(e) => setBannerDescription(e.target.value)}
                      />
                    </div>
                    <div
                      className="form-switch switch-primary d-flex align-items-center gap-3 col-12 mt-16"
                      style={{ paddingLeft: "10px" }}
                    >
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="switch1"
                        checked={addButtonFields}
                        onChange={(e) => setAddButtonFields(e.target.checked)}
                      />
                      <label
                        className="form-check-label fw-semibold text-primary-light text-sm mb-8"
                        htmlFor="switch1"
                      >
                        Add a custom button with title, link, and text
                      </label>
                    </div>
                    {/* Banner Link Field */}
                    {addButtonFields && (
                      <>
                        <div className="col-6 mt-16">
                          <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                            Button Link{" "}
                            <span className="text-danger-600">*</span>
                          </label>
                          {/* <input
                            type="url"
                            className="form-control radius-8"
                            placeholder="Enter banner link (e.g., https://example.com)"
                            value={bannerLink}
                            onChange={(e) => setBannerLink(e.target.value)}
                          /> */}
                          <select
  className="form-control radius-8"
  value={bannerLink}
  onChange={(e) => setBannerLink(e.target.value)}
>
  <option value="">Select button link</option>
  {linkOptions.map((link, index) => (
    <option key={index} value={link.value}>
      {link.label}
    </option>
  ))}
</select>
                        </div>
                        <div className="col-6 mt-16">
                          <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                            Button Title{" "}
                            <span className="text-danger-600">*</span>
                          </label>
                          <input
                            className="form-control radius-8"
                            rows="3"
                            placeholder="Enter button title"
                            value={buttonText}
                            onChange={(e) => setButtonText(e.target.value)}
                          />
                        </div>
                      </>
                    )}

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                      <button
                        type="button"
                        className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        disabled={isDisabled}
                        onClick={handleSliderUpload}
                        className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      >
                        {isEditMode ? "Update" : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show" style={{ zIndex: 1040 }} />
        </div>
      )}

      <style>
        {`
          .slick-slide {
            display: flex !important;
            justify-content: center;
            align-items: center;
          }
          .slick-slide > div {
            width: 100%;
          }
          .slick-track {
            display: flex !important;
            flex-direction: row !important;
          }
          .object-fit-cover {
            object-fit: cover;
          }

          /* Slider Item Styles */
          .slider-item-wrapper {
            position: relative;
            width: 100%;
            height: 500px;
            border-radius: 16px;
            overflow: hidden;
          }

          .slider-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
          }

          .slider-bg-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .slider-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.3) 100%);
          }

          .slider-content {
            position: absolute;
            top: 50%;
            left: 60px;
            transform: translateY(-50%);
            max-width: 100%;
            z-index: 2;
            color: white;
          }

          .slider-badge {
            display: inline-flex;
            align-items: center;
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 1px;
            text-transform: uppercase;
            color: #fff;
            margin-bottom: 20px;
          }

          .slider-title {
            color: #fff;
          }

          .slider-title .highlight {
            color: #dc3545;
          }

          .slider-description {
            font-size: 18px;
            line-height: 1.6;
            margin-bottom: 30px;
            color: rgba(255, 255, 255, 0.9);
          }

          .slider-cta-button {
            display: inline-flex;
            align-items: center;
            padding: 14px 32px;
            background-color: #dc3545;
            color: white;
            font-weight: 600;
            font-size: 16px;
            border-radius: 8px;
            text-decoration: none;
            transition: all 0.3s ease;
          }

          .slider-cta-button:hover {
            background-color: #c82333;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
            color: white;
          }

          .slider-actions {
            position: absolute;
            top: 20px;
            right: 20px;
            z-index: 3;
            display: flex;
            gap: 10px;
          }

          .action-btn {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            cursor: pointer;
            transition: all 0.3s ease;
            backdrop-filter: blur(10px);
          }

          .edit-btn {
            background-color: rgba(36, 62, 133, 0.9);
            color: white;
          }

          .edit-btn:hover {
            background-color: #243e85;
            transform: scale(1.1);
          }

          .delete-btn {
            background-color: rgba(220, 53, 69, 0.9);
            color: white;
          }

          .delete-btn:hover {
            background-color: #dc3545;
            transform: scale(1.1);
          }

          .action-btn .icon {
            font-size: 18px;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .slider-item-wrapper {
              height: 400px;
            }

            .slider-content {
              left: 30px;
              right: 30px;
              max-width: calc(100% - 60px);
            }

            .slider-title {
              font-size: 20px;
            }

            .slider-description {
              font-size: 16px;
            }

            .slider-actions {
              top: 10px;
              right: 10px;
            }
          }

          @media (max-width: 480px) {
            .slider-item-wrapper {
              height: 350px;
            }

            .slider-title {
              font-size: 10px;
            }

            .slider-description {
              font-size: 14px;
            }

            .slider-cta-button {
              padding: 12px 24px;
              font-size: 14px;
            }
          }
        `}
      </style>
    </MasterLayout>
  );
};

export default SliderManagement;
